export default () => {
    return [
        {
            property: 'code',
            header: 'Code',
            columnName: 'voucher_voucher.code',
        },
        {
            property: 'bookingValidUntil',
            header: 'Booking Valid Until',
            columnName: 'voucher_voucher.bookingValidUntil',
        },
        {
            property: 'validUntil',
            header: 'Checkout Valid Until',
            columnName: 'voucher_voucher.validUntil',
        },
        {
            property: 'value',
            header: 'Value',
            columnName: 'voucher_voucher.value',
        },
        {
            property: 'category',
            header: 'Category',
            columnName: 'voucher_voucher.category',
        },
        {
            property: 'description',
            header: 'Description',
            columnName: 'voucher_voucher.description',
        },
        {
            property: 'maximumUsage',
            header: 'Max Usage',
            columnName: 'voucher_voucher.maximumUsage',
        },
        {
            property: 'usageCount',
            header: 'Usage Count',
            columnName: 'voucher_voucher.usageCount',
        },
        {
            property: 'mode',
            header: 'Mode',
            columnName: 'voucher_voucher.mode',
        },
        {
            property: 'productLogicalId',
            header: 'Type',
            columnName: 'voucher_voucher.productLogicalId',
        },
        {
            property: 'countryCode',
            header: 'Country Validity',
            columnName: 'voucher_voucher.country',
        },
    ]
}



// WEBPACK FOOTER //
// ./src/modules/voucher/component/search/voucher-column-list.js